/* DateLozenge.tsx generated by @compiled/babel-plugin v0.36.0 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "color", "children"];
import "./DateLozenge.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { R50, R500, R75, Y50, Y500, Y75, B50, B500, B75, G50, G500, G75, P50, P500, P75, N30A, N800, N40 } from '@atlaskit/theme/colors';
var baseStyles = null;
var onClickStyles = null;
var colorStyles = {
  red: "_bfhk1dda _syazmut4 _irr358wa",
  yellow: "_bfhk1uq3 _syaz1e42 _irr313jf",
  blue: "_bfhk1hdx _syazia9z _irr3ynhg",
  green: "_bfhk1rqq _syaz1v4t _irr315qz",
  purple: "_bfhk1y1p _syazlutv _irr3hbpo",
  grey: "_bfhkq7nr _syaz1fxt _irr3hkel"
};
export var DateLozenge = function DateLozenge(props) {
  var className = props.className,
    _props$color = props.color,
    color = _props$color === void 0 ? 'grey' : _props$color,
    children = props.children,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement("span", _extends({}, rest, {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    className: ax(["_2rko1sit _19pkidpf _2hwxt94y _otyridpf _18u0t94y _v5641y8x _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66 _kqswh2mm _o5721q9c _80omn7od", props.onClick && "_80omtlke", colorStyles[color], className]),
    role: "button"
  }), children);
};